import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import List from './List';
import Render from '../../common/Render';
import { requestDataIfNeeded } from './duck';

class Screen extends React.Component {
  componentDidMount() {
    this.props.requestUsersDataIfNeeded();
  }

  renderAfterLoading = () => {
    const { users } = this.props;

    return <List users={users} />;
  };

  render() {
    const { isLoading, error, t } = this.props;

    return (
      <React.Fragment>
        <h3>
          <span className="u-color-fountain-blue">
            {t('users.titlePrefix')}
          </span>
          {t('users.title')}
          <span className="u-color-fountain-blue">
            {t('users.titleSuffix')}
          </span>
        </h3>

        <Render
          isLoading={isLoading}
          error={error}
          render={this.renderAfterLoading}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ users }) => ({
  isLoading: users.isLoading,
  error: users.error,
  users: users.data,
});

const mapDispatchToProps = { requestUsersDataIfNeeded: requestDataIfNeeded };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/user/users/Screen.js